'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSeed$002dId$0024 from "./presto.types$-Seed-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$55() {
  this.aGA = null;
  this.aGy = null;
  this.aGz = false;
  this.aGw = null;
  this.aGx = false;
  this.aGB = false;
  this.aGC = false;
  this.aGA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$55 as $c_Lpresto_CredentialsView$$anon$55 };
$p = $c_Lpresto_CredentialsView$$anon$55.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$55;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$55() {
}
export { $h_Lpresto_CredentialsView$$anon$55 as $h_Lpresto_CredentialsView$$anon$55 };
$h_Lpresto_CredentialsView$$anon$55.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.aGA;
});
$p.t = (function() {
  if ((!this.aGz)) {
    this.aGy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("seed", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aGz = true;
  }
  return this.aGy;
});
$p.ad = (function() {
  if ((!this.aGx)) {
    this.aGw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSeed$002dId$0024.$m_Lpresto_types$SeedId$().crF(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aGx = true;
  }
  return this.aGw;
});
$p.v = (function() {
  if ((!this.aGC)) {
    this.aGB = false;
    this.aGC = true;
  }
  return this.aGB;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$55 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$55, "presto.CredentialsView$$anon$55", ({
  Gk: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$55 as $d_Lpresto_CredentialsView$$anon$55 };
//# sourceMappingURL=presto.-Credentials-View$$anon$55.js.map
